import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import App from './App.tsx';
import { OidcProvider } from '@axa-fr/react-oidc';
import getOidcConfiguration from './config/oidcConfig';
import LoadingSpinner from './components/common/LoadingSpinner.tsx';
import { AuthProvider } from '@/context/AuthContext.tsx';
import { configStorage } from './config/env';

const initApp = async () => {
  const root = createRoot(document.getElementById('root')!);

  // Show loading spinner while fetching configuration
  root.render(<LoadingSpinner />);

  try {
    const configuration = await getOidcConfiguration(configStorage);

    root.render(
      <StrictMode>
        <OidcProvider
          configuration={configuration}
          callbackSuccessComponent={() => <LoadingSpinner />}
          loadingComponent={() => <LoadingSpinner />}
          authenticatingComponent={() => <LoadingSpinner />}
          sessionLostComponent={() => <LoadingSpinner />}
          authenticatingErrorComponent={() => <LoadingSpinner />}
        >
          <AuthProvider>
            <App />
          </AuthProvider>
        </OidcProvider>
      </StrictMode>
    );
  } catch (error) {
    console.error('Failed to initialize OIDC configuration:', error);
    root.render(
      <div className='flex items-center justify-center h-screen'>
        <div className='text-center'>
          <h1 className='text-2xl font-bold mb-4'>Initialization Error</h1>
          <p className='text-gray-600'>
            Failed to load application configuration. Please refresh the page.
          </p>
        </div>
      </div>
    );
  }
};

initApp();
